const contacts = [
  {
    icon: "ri-mail-send-line",
    title: "提交页面追溯",
    desc: "希望某页面被持续快照监控，或发现有遗漏的旧版，可来信告知页面地址与需求。",
    value: "track@chigua-web.example.com",
    action: "mailto:track@chigua-web.example.com",
    cta: "发起收录申请",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "使用咨询与反馈",
    desc: "关于历史快照、缓存版本、对比功能或会员权益的任何疑问，客服工作日响应。",
    value: "service@chigua-web.example.com",
    action: "mailto:service@chigua-web.example.com",
    cta: "联系客服",
  },
  {
    icon: "ri-arrow-go-back-line",
    title: "内容下架与权利人申诉",
    desc: "如认为某快照涉及你的隐私或权益，我们会在核实后依据规则处理下架诉求。",
    value: "notice@chigua-web.example.com",
    action: "mailto:notice@chigua-web.example.com",
    cta: "提交申诉",
  },
];

export default function ContactSection() {
  return (
    <section id="contact" className="w-full scroll-mt-16 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="overflow-hidden rounded-3xl bg-gradient-to-br from-secondary-500 via-primary-600 to-accent-700 px-6 py-10 md:px-12 md:py-14">
          <div className="mx-auto flex max-w-2xl flex-col items-center text-center">
            <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-background-50/15 text-background-50 backdrop-blur">
              <i className="ri-chat-history-line text-2xl"></i>
            </span>
            <h2 className="mt-5 text-2xl text-background-50 md:text-4xl">需要找回一段被删改的旧版内容？</h2>
            <p className="mt-4 max-w-xl text-sm leading-7 text-background-50/85 md:text-base">
              直接检索历史快照，或把页面交给我们持续追溯。从今以后，每一处修改都有时间点可以回去查看。
            </p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <a
                href="#search"
                className="whitespace-nowrap rounded-lg bg-background-50 px-6 py-3 text-sm font-medium text-primary-700 transition-colors hover:bg-background-100"
              >
                立即检索快照
              </a>
              <a
                href="mailto:track@chigua-web.example.com"
                className="whitespace-nowrap rounded-lg bg-accent-600 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-accent-700"
              >
                提交页面监控
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
          {contacts.map((c) => (
            <div key={c.title} className="flex flex-col rounded-2xl border border-background-200 bg-background-100 p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-primary-700">
                <i className={`${c.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 text-base font-medium text-foreground-950">{c.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-6 text-foreground-700">{c.desc}</p>
              <a
                href={c.action}
                rel="nofollow"
                className="mt-4 flex items-center justify-between rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm text-foreground-800 hover:border-primary-300"
              >
                <span className="truncate">{c.value}</span>
                <i className="ri-arrow-right-up-line shrink-0 text-primary-500"></i>
              </a>
              <a
                href={c.action}
                rel="nofollow"
                className="mt-2 whitespace-nowrap text-right text-xs font-medium text-accent-700 hover:text-accent-800"
              >
                {c.cta}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}